import { DepartmentOrderType, DepartmentType } from "@/enums/enums";
import { DepartmentModel } from "@/model/department/departmentModel";
/* eslint-disable @typescript-eslint/camelcase */
export function GetCreateDepartmentTemplate() {
  return {
    id: 0,
    deptCode: {
      value: "",
      validateError: false,
    },
    nameTh: {
      value: "",
      validateError: false,
    },
    nameEng: {
      value: "",
      validateError: false,
    },
    account: { id: -1 },
  };
}

export function GetEditDepartmentTemplate(departmentDetail: any) {
  return {
    id: departmentDetail.id,
    deptCode: {
      value: departmentDetail.code ? departmentDetail.code : "",
      validateError: false,
    },
    nameTh: {
      value: departmentDetail.nameTh ? departmentDetail.nameTh : "",
      validateError: false,
    },
    nameEng: {
      value: departmentDetail.nameEn ? departmentDetail.nameEn : "",
      validateError: false,
    },
    account: { id: departmentDetail.accountId ? departmentDetail.accountId : -1 },
  };
}

export function ValidateCreateDepartmentTemplate(createDepartmentTemplate: any): boolean {
  const deptCodeValidateError =
    !createDepartmentTemplate.deptCode.value || createDepartmentTemplate.deptCode.validateError;
  const nameThValidateError = !createDepartmentTemplate.nameTh.value || createDepartmentTemplate.nameTh.validateError;
  const nameEngValidateError =
    !createDepartmentTemplate.nameEng.value || createDepartmentTemplate.nameEng.validateError;
  if (!deptCodeValidateError && !nameThValidateError && !nameEngValidateError) {
    return true;
  } else {
    createDepartmentTemplate.deptCode.validateError = deptCodeValidateError;
    createDepartmentTemplate.nameTh.validateError = nameThValidateError;
    createDepartmentTemplate.nameEng.validateError = nameEngValidateError;
    return false;
  }
}

export function ToDepartmentModal(departmentModelTemplate: any, isMain = false): DepartmentModel {
  const departmentModel: DepartmentModel = {
    id: departmentModelTemplate.id,
    code: departmentModelTemplate.deptCode.value,
    nameTh: departmentModelTemplate.nameTh.value,
    nameEn: departmentModelTemplate.nameEng.value,
    isMain: isMain,
    accountId: departmentModelTemplate.account.id == -1 ? null : departmentModelTemplate.account.id,
    type: DepartmentType.Other,
  };

  return departmentModel;
}

export function SetTapsDepartmentTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}

export function SetHeaderDepartmentTable(tableViewModel: any) {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Dept_Code",
      sortBy: DepartmentOrderType.Code,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Dept_Name",
      sortBy: DepartmentOrderType.Name,
      sortingType: null,
      width: 220,
      align: "flex-start",
    },
    {
      name: "Employee_Size",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Adjust_Salary_Account_Code",
      sortBy: DepartmentOrderType.Account,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "In_Use",
      tooltip: "In_Use_Tooltip",
      tooltipPosition: "left",
      sortBy: DepartmentOrderType.Archived,
      sortingType: null,
      align: "flex-start",
      width: 100,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
  ];

  header.forEach((item) => {
    if (item.sortBy === tableViewModel.orderType) {
      item.sortingType = tableViewModel.sortingType;
    } else {
      item.sortingType = null;
    }
  });

  return header;
}
